<template>
    <div class="d-flex justify-content-center align-items-center" style="min-width: 100vw; min-height: 100vh">
        <img src="@/assets/img/redirect.png" alt="R2 Soft" style="width: 500px; height: 500px">
    </div>
</template>

<script>

import User from "@/services/user";
import stores from "@/vuex";
import jwt_decode from 'jwt-decode';

export default {
    name: 'SecurityLogin',
    data() {
        return {}
    },

    mounted() {
        this.loginUser();
    },

    methods: {
        async loginUser() {
            let token = this.$route.params.token;
            await this.$store.dispatch('ActionSingOut');
            User.security(token).then(async (resp) => {
                let userId = jwt_decode(resp.data.accessToken).idUsuario;
                await User.getCompaniesUser(userId, resp.data.accessToken).then(companies => {
                    resp.data.companies = companies.data;
                    resp.data.companyId = resp.data.connection.uuid_exposed;
                    stores.dispatch('ActionDoLoginSecurity', resp.data);
                    this.$router.push({name: 'Home'});
                })
            }).catch(() => {
            })
        }
    }


}
</script>

<style>

</style>
